<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g :clip-path="`url(#${componentId}_clip0_1893_24657)`">
      <path
        d="M14.4015 21.9V15.3C14.4015 15.1409 14.3383 14.9883 14.2257 14.8757C14.1132 14.7632 13.9606 14.7 13.8015 14.7H10.2015C10.0423 14.7 9.88972 14.7632 9.7772 14.8757C9.66468 14.9883 9.60147 15.1409 9.60147 15.3V21.9C9.60147 22.0591 9.53825 22.2117 9.42573 22.3243C9.31321 22.4368 9.16059 22.5 9.00146 22.5H4.80146C4.32408 22.5 3.86624 22.3104 3.52867 21.9728C3.19111 21.6352 3.00146 21.1774 3.00146 20.7V8.1C3.00146 7.14522 3.38075 6.22955 4.05588 5.55442C4.73101 4.87928 5.64669 4.5 6.60146 4.5H17.4015C18.3562 4.5 19.2719 4.87928 19.9471 5.55442C20.6222 6.22955 21.0015 7.14522 21.0015 8.1V20.7C21.0015 21.1774 20.8118 21.6352 20.4743 21.9728C20.1367 22.3104 19.6789 22.5 19.2015 22.5H15.0015C14.8423 22.5 14.6897 22.4368 14.5772 22.3243C14.4647 22.2117 14.4015 22.0591 14.4015 21.9Z"
        :fill="`url(#${componentId}_paint0_linear_1893_24657)`"
      />
      <g :filter="`url(#${componentId}_filter0_b_1893_24657)`">
        <path
          d="M18.0016 1.5C18.3742 1.5 18.7417 1.58675 19.0749 1.75338C19.4082 1.92 19.698 2.16193 19.9216 2.46L23.4016 7.11C23.6418 7.38184 23.8173 7.7046 23.9148 8.05402C24.0124 8.40344 24.0294 8.77043 23.9647 9.12738C23.9 9.48434 23.7552 9.82198 23.5412 10.1149C23.3272 10.4079 23.0496 10.6485 22.7292 10.8187C22.4089 10.9889 22.0541 11.0843 21.6916 11.0976C21.329 11.111 20.9682 11.042 20.6362 10.8958C20.3041 10.7496 20.0096 10.5301 19.7746 10.2537C19.5397 9.9773 19.3704 9.65123 19.2796 9.3H19.1236C18.9894 9.8136 18.6886 10.2682 18.2685 10.5927C17.8483 10.9171 17.3325 11.0931 16.8016 11.0931C16.2708 11.0931 15.7549 10.9171 15.3347 10.5927C14.9146 10.2682 14.6138 9.8136 14.4796 9.3H14.3236C14.1894 9.8136 13.8886 10.2682 13.4685 10.5927C13.0483 10.9171 12.5325 11.0931 12.0016 11.0931C11.4707 11.0931 10.9549 10.9171 10.5347 10.5927C10.1146 10.2682 9.81384 9.8136 9.6796 9.3H9.5236C9.38936 9.8136 9.08863 10.2682 8.66848 10.5927C8.24832 10.9171 7.73245 11.0931 7.2016 11.0931C6.67075 11.0931 6.15488 10.9171 5.73472 10.5927C5.31457 10.2682 5.01384 9.8136 4.8796 9.3H4.7236C4.63279 9.65123 4.46355 9.9773 4.22858 10.2537C3.99362 10.5301 3.69905 10.7496 3.36703 10.8958C3.03501 11.042 2.67416 11.111 2.31163 11.0976C1.9491 11.0843 1.59432 10.9889 1.27395 10.8187C0.953585 10.6485 0.675973 10.4079 0.461986 10.1149C0.247999 9.82198 0.103206 9.48434 0.0384934 9.12738C-0.0262197 8.77043 -0.00916905 8.40344 0.0883634 8.05402C0.185896 7.7046 0.361372 7.38184 0.6016 7.11L4.1596 2.442C4.3838 2.14886 4.67258 1.91137 5.0035 1.74799C5.33441 1.58461 5.69855 1.49975 6.0676 1.5H18.0016Z"
          :fill="`url(#${componentId}_paint1_linear_1893_24657)`"
          fill-opacity="0.6"
        />
        <path
          d="M23.3095 7.17891L23.3092 7.17913L23.3154 7.18615C23.5441 7.44497 23.7112 7.75226 23.8041 8.08494C23.8969 8.41762 23.9132 8.76702 23.8516 9.10687C23.7899 9.44672 23.6521 9.76819 23.4484 10.0471C23.2446 10.326 22.9803 10.5551 22.6753 10.7171C22.3703 10.8792 22.0325 10.97 21.6873 10.9827C21.3422 10.9954 20.9986 10.9297 20.6825 10.7906C20.3664 10.6514 20.0859 10.4424 19.8622 10.1792C19.6385 9.91606 19.4774 9.60561 19.3909 9.27122L19.3687 9.185H19.2796H19.1236H19.0348L19.0123 9.27092C18.8845 9.75991 18.5982 10.1927 18.1982 10.5016C17.7982 10.8105 17.307 10.9781 16.8016 10.9781C16.2962 10.9781 15.805 10.8105 15.405 10.5016C15.005 10.1927 14.7187 9.75991 14.5909 9.27092L14.5684 9.185H14.4796H14.3236H14.2348L14.2123 9.27092C14.0845 9.75991 13.7982 10.1927 13.3982 10.5016C12.9982 10.8105 12.507 10.9781 12.0016 10.9781C11.4962 10.9781 11.005 10.8105 10.605 10.5016C10.205 10.1927 9.91867 9.75991 9.79086 9.27092L9.76841 9.185H9.6796H9.5236H9.43479L9.41234 9.27092C9.28453 9.75991 8.99821 10.1927 8.59819 10.5016C8.19817 10.8105 7.70701 10.9781 7.2016 10.9781C6.69619 10.9781 6.20503 10.8105 5.80501 10.5016C5.40499 10.1927 5.11867 9.75991 4.99086 9.27092L4.96841 9.185H4.8796H4.7236H4.63455L4.61226 9.27122C4.52581 9.60561 4.36467 9.91606 4.14096 10.1792C3.91726 10.4424 3.63681 10.6514 3.32069 10.7906C3.00458 10.9297 2.66103 10.9954 2.31587 10.9827C1.97071 10.97 1.63293 10.8792 1.32791 10.7171C1.02289 10.5551 0.758583 10.326 0.554849 10.0471C0.351116 9.76819 0.213261 9.44672 0.151649 9.10687C0.0900367 8.76702 0.10627 8.41762 0.199129 8.08494C0.291988 7.75226 0.459056 7.44497 0.687773 7.18615L0.688 7.18635L0.693061 7.17971L4.25095 2.51186C4.25097 2.51183 4.25099 2.51181 4.25101 2.51178C4.46446 2.23272 4.73938 2.00664 5.05441 1.85111C5.36947 1.69556 5.71615 1.61476 6.06752 1.615H6.0676H18.0016C18.3563 1.615 18.7062 1.69759 19.0235 1.85623C19.3408 2.01488 19.6168 2.24521 19.8296 2.529L23.3095 7.17891ZM6.0676 1.5H18.0016C18.3742 1.5 18.7417 1.58675 19.0749 1.75338C19.4082 1.92 19.698 2.16193 19.9216 2.46L6.0676 1.5Z"
          :stroke="`url(#${componentId}_paint2_linear_1893_24657)`"
          stroke-width="0.23"
        />
      </g>
    </g>
    <defs>
      <filter
        :id="`${componentId}_filter0_b_1893_24657`"
        x="-1"
        y="0.5"
        width="26.0034"
        height="11.5996"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="0.5" />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_1893_24657"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_1893_24657"
          result="shape"
        />
      </filter>
      <linearGradient
        :id="`${componentId}_paint0_linear_1893_24657`"
        x1="-9.59248"
        y1="18.7828"
        x2="12.4642"
        y2="37.9043"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F8B700" />
        <stop offset="0.51" stop-color="#F87900" />
        <stop offset="1" stop-color="#AE35DD" />
      </linearGradient>
      <linearGradient
        :id="`${componentId}_paint1_linear_1893_24657`"
        x1="0"
        y1="11.0993"
        x2="24.0032"
        y2="11.0993"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F87900" />
        <stop offset="0.510667" stop-color="#FE4F45" />
        <stop offset="1" stop-color="#E419BA" />
      </linearGradient>
      <linearGradient
        :id="`${componentId}_paint2_linear_1893_24657`"
        x1="3.82092"
        y1="2.61833"
        x2="7.4842"
        y2="13.9634"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" stop-opacity="0.25" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </linearGradient>
      <clipPath :id="`${componentId}_clip0_1893_24657`">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  props: {
    componentId: {
      type: String,
      default: ''
    }
  }
}
</script>
